// EXAMPLE besploke ts for this site only.

export const myScript = () => { }

class App {
    private header = document.querySelector("[data-header]");
    private navToggleButton = document.querySelector("[data-toggle]")
    private navBar = document.querySelector("[data-nav]")
    private navBarList = document.querySelector(".navItems")
    private navBarListItem = Array.from(document.querySelectorAll(".navItem"))
    private navBarDropdown = document.querySelector("[data-dropdown]")
    private navBarDropdownListItem = Array.from(document.querySelectorAll(".navBarDropdownItem"))

    constructor() {
        this.initApp()
    }

    private initApp(): void {
        this.navToggleButton?.addEventListener("click", this.handleNavigationToggle.bind(this))
        this.handleActiveLinkOnclick()
        // this.handleActiveLinkOnPageLoad()
        // this.inifiniteCarousel()
    }

    private getCurrentPage(): string {
        return window.location.pathname;
    }

    private handleNavigationToggle(): void {
        this.navBar?.toggleAttribute("data-menu-open")
        this.navBar?.setAttribute("aria-expanded", "")
        if (this.navBar?.hasAttribute("data-menu-open")) {
            this.navBar.setAttribute("aria-expanded", "true")
            this.navToggleButton?.setAttribute("aria-expanded", "true")
        } else {
            this.navBar?.setAttribute("aria-expanded", "false")
            this.navToggleButton?.setAttribute("aria-expanded", "false")
        }
    }

    private handleActiveLinkOnclick(): void {
        this.navBarList?.addEventListener("click", (e) => {
            // store the target value in a variable
            const target = e.target as HTMLAnchorElement;

            // get target attribute for current page
            const currentPage = target.getAttribute("href");

            // show the navbar menu
            target.nextElementSibling?.toggleAttribute("data-dropdown-menu")

            // If link is already active on page load, move on.
            if (target.closest(".navItem")?.classList.contains("active")) return

            // clear the active state if no link is already active on page load
            this.navBarListItem.forEach(listItem => listItem.classList.remove("active"));
            this.navBarDropdownListItem.forEach(listItem => listItem.classList.remove("active"));

            // check the parent element of target value and add active state to the parent when clicked
            // TODO: check if target href attribute matches current page url
            if (target.closest("a") && currentPage === this.getCurrentPage()) {
                target.closest("a")?.classList.add("active")
            }

            if (target.closest(".navBarDropdownItem") && currentPage === this.getCurrentPage()) {
                target.closest(".navBarDropdownItem")?.classList.add("active")
            }


            // console.log(this.getCurrentPage(), currentPage);

        })
    }

}

export const aasScript = new App();